export default __webpack_public_path__ + "static/media/4、首页有气草本.bc0a095f.jpg";